export default {
  toasts: {
    failed_to_delete_website: 'Error al eliminar el sitio web',
    website_deleted: 'Sitio web eliminado',
  },
  delete_model: {
    title: '¿Seguro que quieres eliminar el sitio web?',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
  },
  buttons: {
    open_editor: 'Abrir editor',
    transfer_website: 'Transferir sitio web',
    delete_site: 'Eliminar',
  },
};
